<script>
    import { slide } from 'svelte/transition';


    export let title = undefined;
    export let items = [];
    export let collapsible  = false;
    export let expanded = false;
    export let selectable = true;
    export let error_msg = '';
    export let is_crew_check_first = true;
    export let changed = null;

    $: selected_items = items.filter((i)=>{ return i.a === true; }).length;

    function toggleSelection(idx) {
        items[idx]['a'] = !(items[idx]['a']);
        const role_selected_items = items.filter(x => x['a']);
        for (let i = 0; i < items.length; i ++) {
            if (role_selected_items.length) {
                if (items[i]['role'] === role_selected_items[0]['role'] && role_selected_items[0]['role'] !== 'contractor') {
                    items[i].disabled = false;
                } else {
                    if (items[i]['uid'] !== role_selected_items[0]['uid']) {
                        items[i].disabled = true;
                    }
                }
            } else {
                items[i].disabled = false;
            }
        }
        if (changed) changed();
    }
    function toggleExpanded() {
        console.log("doing it!");
        expanded = !expanded;
    }
</script>

<div class="itemholder">
    {#if title !== undefined}
        {#if collapsible}
        <button on:click={() => {toggleExpanded();}} class="title">{title} ({selected_items}) <i class="fas fa-chevron-{(expanded) ? "up" : "down"}"></i></button>
        {:else}            
        <button class="title">{title}</button>
        {/if}
    {/if}
    {#if (!collapsible) || (collapsible && expanded) }
    {#each items as item, idx}
        <div transition:slide class="item {item.disabled ? "disabled" : ""}">
            <button disabled={!selectable} on:click={()=>{toggleSelection(idx);}} style="margin-bottom: 1px;"><i class="far fa-{(item.a) ? "check-" : "" }square"></i> {item.t}</button>
            <a class="action" href={item.r_role === 'landscaper' ? '#/Settingscompany' : `#/User_Review?uid=${item.uid}`} target="_blank" style="padding-top: 7px;">
                <i class="far fa-eye" style="margin-right: 10px;"></i>
            </a>
        </div>
    {/each}
    {/if}
</div>
<div class="helper-text {(selected_items === 0 && !is_crew_check_first) ? "error" : ""}">
    <div class="helper-text-holder">
        {(selected_items === 0 && !is_crew_check_first) ? error_msg : ''}
    </div>
</div>

<style>
    .disabled {
        pointer-events: none;
        opacity: 0.5;
    }
    .itemholder {
        width: 100%;
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: column;
    }
    button.title {
        width: 100%;
        font-weight: bold;
        border: none;
        background-color: white;
        font-family: Poppins, "Font Awesome 5 Pro", "FontAwesome", "Font Awesome 5 Free" !important;	
        margin-bottom: 2px;
    }

    .item {
        width: 100%;
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .item button {
        width: 100%;
        height: 100%;
        border: none;
        text-align: left;
        background-color: white;
    }
    .item button:disabled {
        cursor: not-allowed;
    }
    a.action {
        width: 60px !important;
        text-align: right;
    }
    a.action i{
        color: #1769aa;
    }
    .helper-text {
        width: 100%;
        color: #357a38;
        font-size: 12px;
    }
    .helper-text-holder {
        width: 100%;
        padding: 5px;
    }
    .error {
        color: #d90000 !important;
    }
</style>